export const hideFiltersIconStyles = {
    width: '10px',
    height: '12px',
};

export const showFiltersIconStyles = {
    width: '9px',
    height: '14px',
};
